<script lang="ts">
	import "./layout.css";
	import { auth } from "#lib/auth.svelte.js";
	import { browser } from "$app/env";
	import { stopRealtime } from "#lib/realtime/ws.svelte.js";
	import { Toaster } from "#lib/components/ui/sonner/index.js";
	let { children } = $props();

	$effect(() => {
		if (browser) {
			auth.checkAuth();
		}
	});

	// Signed out on any page (including the login/2FA pages) means no socket and
	// no reconnect attempts. This sits in the root layout so it also covers
	// routes outside the authenticated group, where the session can end while a
	// socket from a previous page is still reconnecting.
	$effect(() => {
		if (browser && !auth.loading && !auth.user) {
			stopRealtime();
		}
	});
</script>

<Toaster position="top-right" richColors duration={8000} />
{@render children()}
